export const detectIsCNPJ = (value) => /[A-Z]/.test(value) || value.length > 11;
